import colors from './colors'

export const DarkTheme = {
  colors,
  fonts: {
    main: 'Helvetica Neue, Helvetica, Arial, Sans Serif',
  },
  borderRadius: {
    button: '5px',
  },
  responsive: {
    small: '700px',
  },
}
